import React from 'react';
import SmartNavbar from '../components/SmartNavbar';
import Footer from '../components/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <SmartNavbar />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 prose prose-blue max-w-none">
          <p className="text-sm text-gray-500 mb-6">
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Introduction</h2>
          <p className="text-gray-700 mb-4">
            Welcome to Snaptura. We respect your privacy and are committed to protecting your personal data. 
            This privacy policy will inform you about how we handle your personal data when you use our service.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Information We Collect</h2>
          <p className="text-gray-700 mb-4">We collect the following types of information:</p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li className="mb-2"><strong>Account Information:</strong> Email address, name, and password when you register.</li>
            <li className="mb-2"><strong>Usage Data:</strong> API requests, timestamps, and usage statistics.</li>
            <li className="mb-2"><strong>Payment Information:</strong> Billing details processed securely through Stripe (we don't store credit card information).</li>
            <li className="mb-2"><strong>Technical Data:</strong> IP address, browser type, and device information.</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. How We Use Your Information</h2>
          <p className="text-gray-700 mb-4">We use your information to:</p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li className="mb-2">Provide and maintain our API service</li>
            <li className="mb-2">Process payments and manage subscriptions</li>
            <li className="mb-2">Monitor usage and enforce rate limits</li>
            <li className="mb-2">Send important service updates and notifications</li>
            <li className="mb-2">Improve our service and develop new features</li>
            <li className="mb-2">Comply with legal obligations</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Data Storage and Security</h2>
          <p className="text-gray-700 mb-4">
            Your data is stored securely using industry-standard encryption. We use Supabase for database hosting 
            and implement appropriate security measures to protect against unauthorized access, alteration, or destruction 
            of your personal information.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Data Sharing</h2>
          <p className="text-gray-700 mb-4">
            We do not sell your personal data. We may share your information with:
          </p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li className="mb-2"><strong>Service Providers:</strong> Such as Stripe for payment processing</li>
            <li className="mb-2"><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Your Rights</h2>
          <p className="text-gray-700 mb-4">You have the right to:</p>
          <ul className="list-disc pl-6 mb-4 text-gray-700">
            <li className="mb-2">Access your personal data</li>
            <li className="mb-2">Correct inaccurate data</li>
            <li className="mb-2">Request deletion of your data</li>
            <li className="mb-2">Export your data</li>
            <li className="mb-2">Opt-out of marketing communications</li>
          </ul>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">7. Data Retention</h2>
          <p className="text-gray-700 mb-4">
            We retain your personal data only as long as necessary to provide our services and comply with legal obligations. 
            You can request deletion of your account at any time through your account settings.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">8. Cookies</h2>
          <p className="text-gray-700 mb-4">
            We use essential cookies to maintain your session and improve your experience. 
            See our <a href="/cookie-policy" className="text-blue-600 hover:underline">Cookie Policy</a> for more details.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">9. Children's Privacy</h2>
          <p className="text-gray-700 mb-4">
            Our service is not intended for users under 18 years of age. We do not knowingly collect personal 
            information from children.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">10. Changes to This Policy</h2>
          <p className="text-gray-700 mb-4">
            We may update this privacy policy from time to time. We will notify you of any changes by posting 
            the new policy on this page and updating the "Last updated" date.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">11. Contact Us</h2>
          <p className="text-gray-700 mb-4">
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p className="text-gray-700">
            Email: <a href="mailto:privacy@snaptura.online" className="text-blue-600 hover:underline">privacy@snaptura.online</a>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}